export default "__VITE_ASSET__Cb$v9xtw__"